<div class="tt-common-dialog_header">
  <div class="tt-common-dialog_header-left">
    @if (data?.icon) {
      <mat-icon [icon]="data.icon" [iconSize]="20" />
    }
    <h2 class="tt-common-dialog_header-title" data-testid="tt-common-dialog_title">
      {{ data?.title | transloco: data?.titleParams }}
    </h2>
  </div>

  <button data-testid="tt-common-dialog_close-button" dialogClose ttButton [emphasis]="'minimal'" [size]="'icon'" >
    <mat-icon [icon]="'x'" [iconSize]="16" />
  </button>
</div>

<ng-container cdkPortalOutlet />
